// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  stringMustBeGreaterThanOrEqualZero,
  valueIsRequired,
} from 'validators/common/simple'

// required && X >= 0
const requiredStringMustBeGreaterThanOrEqualZero = v => (
  valueIsRequired(v) ||
  stringMustBeGreaterThanOrEqualZero(v)
)

export default requiredStringMustBeGreaterThanOrEqualZero
